module.exports = __webpack_public_path__ + "img/audio-en-active.b9fde9d7.gif";